<script>
import {
  DatePicker, Col, Form, FormItem, Input, Option, RadioGroup, Radio, Row, Select
} from 'element-ui';
import { formItemFun } from '@/utils/formConfig';
import RemoteSearch from '@/components/common/RemoteSearch';

export default {
  components: {
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
    ElInput: Input,
    ElCol: Col,
    ElForm: Form,
    ElFormItem: FormItem,
    ElRow: Row,
    ElRadioGroup: RadioGroup,
    ElRadio: Radio,
    RemoteSearch
  },
  props: {
    formConfig: {
      type: Object,
      default() {
        return {
          'label-width': '80px',
          'label-position': 'left',
          ref: 'ly-form',
          class: 'ly-form-inline ly-form-one-line'
        };
      }
    },
    formKeys: {
      required: true,
      type: Object
    },
    defaultFormItem: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {},
  data() {
    return {
      nativeFormConfig: {
        inline: true,
        'status-icon': true
      },
      formData: {},
      formRules: {},
      formItemsList: {},
      nativeFormKeys: [],
      autoInputKeys: {} // 用于级联查询相关操作
    };
  },
  watch: {
    defaultFormItem() {
      this.init();
    },
    formKeys() {
      this.init();
    }
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      // 预先清空校验，防止表单默认值改变的时触发校验
      this.formRules = {};
      this.nativeFormConfig = Object.assign({}, this.nativeFormConfig, window.cloneDeep(this.formConfig));

      if (this.formKeys instanceof Array) {
        this.formItemsList = formItemFun(this.formKeys);
        this.nativeFormKeys = this.formKeys;
      } else {
        this.formItemsList = this.formKeys;
        this.nativeFormKeys = Object.keys(this.formKeys);
      }
      this.formData.postDataTemp = {};
      // 为代码可读性，统一在这里遍历增加form vm data
      const rules = {};
      this.nativeFormKeys.map(item => {
        let value = '';
        const curItem = this.formItemsList[item];
        if (this.defaultFormItem && typeof this.defaultFormItem[item] !== 'undefined') {
          value = this.defaultFormItem[item];
          // 设置动态查询的select默认值
          if (curItem.type === 'select' && curItem.options.select.length === 0) {
            curItem.options.select = [{
              [curItem.options.valueKey]: this.defaultFormItem[item],
              [curItem.options.labelKey]: this.defaultFormItem[curItem.labelKey]
            }];
          }
        }
        // 冗余回传数据
        if (curItem.options && Array.isArray(curItem.options.postData)) {
          curItem.options.postData.forEach(key => {
            this.formData.postDataTemp[key] = this.defaultFormItem[key];
          });
        }
        this.$set(this.formData, item, value);
        if (curItem.rules) {
          curItem.rules = curItem.rules.map(ru => {
            const tmpRu = ru;
            if (ru.validator) {
              // 为匿名validator验证函数设置this
              tmpRu.validator = ru.validator.bind(this);
            }
            return tmpRu;
          });
        }
        rules[item] = curItem.rules;
        // 级联查询相关操作,用来监控级联变化时清空值
        if (curItem.type === 'autoInput' && curItem.options.paramsKeys) {
          const tmp = { ...this.autoInputKeys };
          curItem.options.paramsKeys.map(key => {
            if (tmp[key] && tmp[key].indexOf(item) === -1) tmp[key].push(item);
            else tmp[key] = [item];
            return key;
          });
          this.autoInputKeys = {
            ...this.autoInputKeys,
            ...tmp
          };
        }
        return item;
      });
      this.$nextTick(() => {
        // 异步添加校验
        this.formRules = rules;
      });
    },
    handleInputChange(key, value, labelKey, labelValue, obj) {
      // let tempValue = value;
      // todo, 默认全部trim，有待商榷
      // if (typeof value === 'string') tempValue = value.trim(value);
      this.formData[key] = value;
      // 冗余回传数据
      if (this.formKeys[key].options && Array.isArray(this.formKeys[key].options.postData)) {
        this.formKeys[key].options.postData.forEach(keyCur => {
          if (obj && keyCur in obj) {
            this.formData.postDataTemp = {
              ...this.formData.postDataTemp,
              [keyCur]: obj[keyCur]
            };
          }
        });
      }
      if (labelKey) this.formData[labelKey] = labelValue;
      // 针对需要动态计算的表单，正常取值请主动使用getFormData
      this.$emit('change', this.formData, key, obj);
      // 针对级联查询，如果有限制条件，限制条件变化时清空
      let defValue = '';
      if (this.defaultFormItem) defValue = this.defaultFormItem[key];
      if (this.autoInputKeys[key] && this.formData[key] !== defValue) {
        this.autoInputKeys[key].map(item => {
          this.$refs[`${item}autoInput`].clear();
          this.formData[item] = '';
          return item;
        });
      }
    },
    // 针对disabled的input注入自动计算的值
    setFormData(key, value) {
      this.formData[key] = value;
      this.$emit('change', this.formData, key);
    },
    resetFields() {
      // 清空表单
      this.$refs.lyForm.resetFields();
      Object.keys(this.formData).map(key => {
        if (Array.isArray(this.formData[key])) {
          this.formData[key] = [];
          return key;
        }
        this.formData[key] = '';
        return key;
      });
      this.nativeFormKeys.map(key => {
        if (this.$refs[`${key}autoInput`]) this.$refs[`${key}autoInput`].clear();
        return key;
      });
    },
    isItemDisAbled(key) {
      // 有级联相关的disabled控制
      const item = this.formItemsList[key];
      if (!item.options || !item.options.paramsKeys) return false;
      return item.options.paramsKeys.every(keyc => !this.formData[keyc]);
    },
    getFormData() {
      return new Promise(resolve => {
        this.$refs.lyForm.validate(valid => {
          if (valid) {
            return resolve({ valid, data: { ...this.formData } });
          }
          return resolve({ valid: false, data: null });
        });
      });
    },
    getFormItemByType(item, key) {
      let defaultData = {};
      const paramsData = {};
      switch (item.type) {
        case 'text':
          return (
            <el-input
              type="text"
              value={this.formData[key]}
              placeholder={item.placeholder}
              disabled={this.isItemDisAbled(key)}
              {...{ attrs: item.options }}
              onInput={value => this.handleInputChange(key, value)}
            >
              {item.options
              && item.options.inputSlot && item.options.inputSlot.map(obj => (
                <div slot={obj.type || 'append'}>{<div domProps={{ innerHTML: obj.value } }></div>}</div>
              ))}
            </el-input>
          );
        case 'date':
          return (
            <el-date-picker
              value={this.formData[key]}
              placeholder={item.placeholder}
              onInput={value => this.handleInputChange(key, value)}
              disabled={this.isItemDisAbled(key)}
              {...{ attrs: item.options }}
            ></el-date-picker>
          );
        case 'select':
          return (
            <el-select
              placeholder={item.placeholder}
              value={this.formData[key]}
              onInput={value => this.handleInputChange(key, value)}
              disabled={this.isItemDisAbled(key)}
              {...{ attrs: item.options }}
            >
              {item.options.select.map(childItem => {
                if (item.options.valueKey) return <el-option label={childItem[item.options.labelKey]} value={childItem[item.options.valueKey]}></el-option>;
                return <el-option {...{ attrs: childItem }}></el-option>;
              })}
            </el-select>
          );
        case 'time':
          return (
            <el-time-picker
              is-range
              arrow-control
              value={this.formData[key]}
              onInput={value => this.handleInputChange(key, value)}
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              disabled={this.isItemDisAbled(key)}
            ></el-time-picker>
          );
        case 'radio':
          return (
            <el-radio-group
              value={this.formData[key]}
              onInput={value => this.handleInputChange(key, value)}
              disabled={this.isItemDisAbled(key)}
              {...{ attrs: item.options }}
            >
              {item.options.radios.map(childItem => (
                <el-radio border label={childItem[item.options.key]}>
                  {childItem[item.options.label]}
                </el-radio>
              ))}
            </el-radio-group>
          );
        case 'autoInput': // 远程搜索框，有两种类型 input 和 select
          if (this.defaultFormItem && this.defaultFormItem[key]) {
            // 设置默认值
            defaultData = {
              options: [
                {
                  [item.options.value]: this.defaultFormItem[key],
                  [item.options.label]: this.defaultFormItem[item.labelKey]
                }
              ],
              value: this.formData[key]
            };
          }
          // 级联查询时参数注入
          if (item.options.paramsKeys) {
            item.options.paramsKeys.map(pkey => {
              paramsData[pkey] = this.formData[pkey];
              return pkey;
            });
          }
          return (
            <remote-search
              ref={`${key}autoInput`}
              defaultData={defaultData}
              paramsData={paramsData}
              options={{ ...item.options, key }}
              onInput={(value, label, obj) => this.handleInputChange(key, value, item.labelKey, label, obj)}
            ></remote-search>
          );
        case 'slot':
          return this.$scopedSlots[key]({ item, formData: this.formData });
        default:
          return null;
      }
    }
  },
  render() {
    return (
      <el-row class='ly-form'>
        <el-form
          ref="lyForm"
          props={{ model: this.formData }}
          rules={this.formRules}
          size="small"
          {...{ attrs: { ...this.nativeFormConfig, 'validate-on-rule-change': false } }}
        >
          {this.nativeFormKeys.map(key => {
            const item = this.formItemsList[key];
            if (this.nativeFormConfig.itemSpan) {
              return (
                <el-col
                  key={key}
                  span={item.options ? item.options.itemSpan || this.nativeFormConfig.itemSpan : this.nativeFormConfig.itemSpan}
                  class={item.options && item.options.class}
                >
                  <el-form-item label={item.label} prop={key}>
                    {this.getFormItemByType(item, key)}
                  </el-form-item>
                </el-col>
              );
            }
            return (
              <el-form-item key={key} label={item.label} prop={key}>
                {this.getFormItemByType(item, key)}
              </el-form-item>
            );
          })}
        </el-form>
      </el-row>
    );
  }
};
</script>

<style lang="less">
.ly-form-action .el-form-item__label {
  opacity: 0;
}
</style>
